import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import actions from "../../Store/actions";
import { useAuthenticated } from "../../common/hooks";
import { strings } from "../../common/i18n";
import { history } from "../../common/lib";
import config from "../../config";
import MatReactTable from "../../common/components/MaterialReactTable";
import { logToSentry } from "../../config/Sentry/";

const PARAM_GEN_DATE = "gen_date";
const PARAM_TOKEN = "token";
const PARAM_UPLOAD_ID = "upload_id";

/**
 * Validation Errors Component
 */

const ValidationErrors = () => {
    const dispatch = useDispatch();
    const { hasIdToken, isExpired } = useAuthenticated();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const params = useParams();
    const { validationErrors } = useSelector((state) => state);

    /** Columns  */
    const columns = useMemo(() => {
        return [
            {
                accessorKey: "row",
                header: strings("row"),
                enableHiding: false,
                size: 80
            },
            {
                accessorKey: "branch",
                header: strings("branch")
            },
            {
                accessorKey: "assetIdentifier",
                header: strings("assetIdentifier")
            },
            {
                accessorKey: "assetIdentifier2",
                header: strings("identifier2")
            },
            {
                accessorKey: "branchReference",
                header: strings("ref")
            },
            {
                accessorKey: "error",
                header: strings("error"),
                enableHiding: false,
                size: 300
            }
        ];
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (Boolean(location.search)) {
                    const urlSearchParams = new URLSearchParams(
                        location.search
                    );
                    const genDate = urlSearchParams.get(PARAM_GEN_DATE);
                    const token = urlSearchParams.get(PARAM_TOKEN);
                    const uploadId = urlSearchParams.get(PARAM_UPLOAD_ID);
                    if (hasIdToken && !isExpired) {
                        history.push(
                            `/${config.paths.auth}/${config.paths.dataCheck}/${uploadId}`
                        );
                    } else if (moment().isAfter(moment(genDate))) {
                        dispatch(
                            actions.toast.create.error(strings("tokenExpired"))
                        );
                    } else {
                        await dispatch(
                            actions.validationErrors.create.getRequest(
                                uploadId,
                                token
                            )
                        );
                    }
                } else if (params.uploadId) {
                    const { uploadId } = params;
                    await dispatch(
                        actions.validationErrors.create.getRequest(uploadId)
                    );
                }
            } catch (error) {
                const errStr = error.toString();
                console.error(errStr);
                logToSentry("On data-check validation:", { error });
                dispatch(
                    actions.toast.create.error(
                        strings("errors.onLoadFailedValidation")
                    )
                );
            } finally {
                setLoading(false);
            }
        };
        dispatch(
            actions.appSettings.create.set({
                appBarTitle: strings("dataCheck")
            })
        );
        fetchData();
    }, []);

    const { data } = validationErrors;

    return (
        <MatReactTable
            persistKey="dataCheckValidationErrors"
            columns={columns}
            data={data}
            loading={loading}
            noRowsMessage={strings("messages.noValidationErrors")}
        />
    );
};

export default ValidationErrors;
